import React from "react";
import { Box, Image } from "@chakra-ui/react";
import { useNavigate } from "@remix-run/react";
import { AskDoubtAccordionStyles } from "./AskDoubtAccordionStyles";
import { tutorString, urlString } from "../../../utils/common-utils";
import accordion_images from "../../../utils/accordion/accordion_images";

//Ask a Doubt module
const AskDoubtAccordion = ({
  topics,
  isSideNav = false,
  isTutor,
  selectedTopic,
  onClickSubject,
}) => {
  const navigate = useNavigate();

  return (
    <Box sx={AskDoubtAccordionStyles(isSideNav).container}>
      {!isSideNav && (
        <Image
          src={accordion_images.doubtVin}
          sx={AskDoubtAccordionStyles(isSideNav).vinIcon}
        />
      )}
      <Box
        sx={AskDoubtAccordionStyles(isSideNav).askDoubtBox}
        onClick={() => {
          if (isSideNav) {
            // SIDE NAV DOUBT
            navigate(`${urlString}/doubt`, {
              state: {
                subjectMasterUuid: topics?.subject?.subjectMasterUuid,
                subject: topics?.subject?.subjectMasterUuid,
                topic: topics?.topic?.topicId,
                topicName: topics?.topic?.topicInfo?.name,
                subjectName: topics?.topic?.topicInfo?.subject_name,
                topicMasterUuid: topics?.topic?.topicMasterUuid,
              },
            });
          } else if (!isSideNav && !isTutor) {
            // ACCORDION VIEW DOUBT B2B
            navigate(`${urlString}/doubt`, {
              state: {
                subjectMasterUuid: selectedTopic?.subject?.subjectMasterUuid,
                subject: selectedTopic?.topic?.topicInfo?.subject_name,
                topic: selectedTopic?.topic?.topicInfo?.name,
                topicName: selectedTopic?.topic?.topicInfo?.name,
                subjectName: selectedTopic?.topic?.topicInfo?.subject_name,
                topicMasterUuid: selectedTopic?.topic?.topicMasterUuid,
              },
            });
          } else if (isTutor && !isSideNav) {
            //ACCORDION VIEW DOUBT B2C
            navigate(`${tutorString}/doubt`, {
              state: {
                subjectMasterUuid: onClickSubject?.master_uuid,
                subject: onClickSubject?.name,
                topic: selectedTopic?.masterId,
                topicName: selectedTopic?.name,
                subjectName: onClickSubject?.name,
                topicMasterUuid: selectedTopic?.masterId,
              },
            });
          }
        }}
        cursor={"pointer"}
      >
        Ask your doubts!
      </Box>
      {isSideNav && <Image src={accordion_images.doubtVin} />}
    </Box>
  );
};

export default AskDoubtAccordion;
